import React from "react";
import {
  Box,
  Container,
  useTheme,
} from "@mui/material";

const UserLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Main content area - full width without sidebar */}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          pt: 3,
          px: { xs: 2, sm: 3, md: 4 },
          background:
            "linear-gradient(135deg, #f0f4f8 0%, #e1e8ed 50%, #e3f2fd 100%)",
        }}
      >
        {/* Main Content - Full Width */}
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            maxWidth: "1600px",
            mx: "auto",
          }}
        >
          <Container maxWidth={false} disableGutters sx={{ height: "100%" }}>
            {children}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default UserLayout;
